// Normalizza un numero di telefono italiano nel formato richiesto da wa.me (solo cifre, con prefisso internazionale)
export function toWhatsappNumber(phone) {
  if (!phone) return null;
  let digits = String(phone).replace(/\D/g, '');
  if (!digits) return null;
  if (digits.startsWith('00')) digits = digits.slice(2); // 0039...
  if (digits.startsWith('39') && digits.length >= 11) return digits; // già con prefisso Italia
  if (digits.startsWith('3') && digits.length === 10) return `39${digits}`; // cellulare italiano senza prefisso
  if (digits.startsWith('0')) return `39${digits}`; // fisso italiano senza prefisso
  return digits; // numero estero già con prefisso
}

export const whatsappLink = (phone) => {
  const number = toWhatsappNumber(phone);
  return number ? `https://wa.me/${number}` : null;
};
